const RENAMES: Array<[from: string, to: string]> = [
  ['requiem-theme', 'pridex-theme'],
  ['requiem-notification-sound', 'pridex-notification-sound'],
];

try {
  for (const [from, to] of RENAMES) {
    const value = localStorage.getItem(from);
    if (value !== null && localStorage.getItem(to) === null) localStorage.setItem(to, value);
  }
} catch {
}
